import React, { useState } from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

export default function HistoryModule({ data }) {
  const [visibleItems, setVisibleItems] = useState(5);

  const handleSeeMore = () => {
    setVisibleItems((prev) => prev + 5);
  };

  // If data is undefined or null, use an empty array
  const historyData = data || [];
  // Slice the data to only show the most recent items
  const visibleData = historyData.slice(-visibleItems).reverse();
  // Calculate remaining unseen items
  const unseenCount = historyData.length - visibleItems;

  return (
    <div className="section-box mt-4">
      <div className="font-semibold text-eleghoBlue text-lg border-b border-gray-400">
        History
      </div>
      <div className="mt-4 flex flex-col w-full">
        {visibleData.map((history, index) => (
          <div key={index} className="relative border-l border-gray-300">
            <div className="flex items-center relative -left-4">
              <div className=" bg-white p-1 rounded-full text-green-500">
                <CheckCircleOutlineIcon />
              </div>
              <div className="text-xs">
                {history.action} {history.to}
              </div>
            </div>
            <div className="pl-4 mb-4">
              <div className="text-xs text-gray-400">{history.at}</div>
              <div className="text-xs font-semibold text-gray-400">
                {history.by}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Show "See More" button only if there are more items to display */}
      {visibleItems < historyData.length && (
        <div className="mt-3 text-center">
          <button
            onClick={handleSeeMore}
            className="text-eleghoBlue hover:text-blue-700 text-sm font-medium"
          >
            See More ({unseenCount} more)
          </button>
        </div>
      )}
    </div>
  );
}
